import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ButtonSmall } from "../components/Button";
import { ThemeContext } from "../context/ThemeContext";
import logoImg from "../img/smallLogo.png";
import { getMbtiMatchPercent, getRandomPercentByMatch } from "../util/util";
import Number from "../components/Number";

function ResultPage() {
  const { selectMyState, selectYourState } = useContext(ThemeContext);
  const [currentStyle, setCurrentStyle] = useState({
    color: "#000",
    backgroundColor: "#fff",
  });
  const [currentYourStyle, setCurrentYourStyle] = useState({
    color: "#000",
    backgroundColor: "#fff",
  });

  useEffect(() => {
    // selectMyState style change
    if (
      selectMyState === "INTJ" ||
      selectMyState === "INTP" ||
      selectMyState === "ENTJ" ||
      selectMyState === "ENTP"
    ) {
      const changeObject = { ...currentStyle };
      changeObject.color = "#b14eff";
      changeObject.border = "3px solid #b14eff";
      setCurrentStyle(changeObject);
    } else if (
      selectMyState === "INFJ" ||
      selectMyState === "INFP" ||
      selectMyState === "ENFJ" ||
      selectMyState === "ENFP"
    ) {
      const changeObject = { ...currentStyle };
      changeObject.color = "#76d4b0";
      changeObject.border = "3px solid #76d4b0";
      setCurrentStyle(changeObject);
    } else if (
      selectMyState === "ISTJ" ||
      selectMyState === "ISFP" ||
      selectMyState === "ESTJ" ||
      selectMyState === "ESFJ"
    ) {
      const changeObject = { ...currentStyle };
      changeObject.color = "#5099ca";
      changeObject.border = "3px solid #5099ca";
      setCurrentStyle(changeObject);
    } else if (
      selectMyState === "ISTP" ||
      selectMyState === "ISFP" ||
      selectMyState === "ESTP" ||
      selectMyState === "ESFP"
    ) {
      const changeObject = { ...currentStyle };
      changeObject.color = "#EAD51F";
      changeObject.border = "3px solid #EAD51F";
      setCurrentStyle(changeObject);
    }

    // selectYourState style change
    if (
      selectYourState === "INTJ" ||
      selectYourState === "INTP" ||
      selectYourState === "ENTJ" ||
      selectYourState === "ENTP"
    ) {
      const changeObject = { ...currentYourStyle };
      changeObject.color = "#b14eff";
      changeObject.border = "3px solid #b14eff";
      setCurrentYourStyle(changeObject);
    } else if (
      selectYourState === "INFJ" ||
      selectYourState === "INFP" ||
      selectYourState === "ENFJ" ||
      selectYourState === "ENFP"
    ) {
      const changeObject = { ...currentYourStyle };
      changeObject.color = "#76d4b0";
      changeObject.border = "3px solid #76d4b0";
      setCurrentYourStyle(changeObject);
    } else if (
      selectYourState === "ISTJ" ||
      selectYourState === "ISFJ" ||
      selectYourState === "ESTJ" ||
      selectYourState === "ESFJ"
    ) {
      const changeObject = { ...currentYourStyle };
      changeObject.color = "#5099ca";
      changeObject.border = "3px solid #5099ca";
      setCurrentYourStyle(changeObject);
    } else if (
      selectYourState === "ISTP" ||
      selectYourState === "ISFP" ||
      selectYourState === "ESTP" ||
      selectYourState === "ESFP"
    ) {
      const changeObject = { ...currentYourStyle };
      changeObject.color = "#EAD51F";
      changeObject.border = "3px solid #EAD51F";
      setCurrentYourStyle(changeObject);
    }
  }, []);

  return (
    <div id="contents" className="subWrap">
      <h1>
        <Link to="/" onClick="window.location.reload()">
          찰떡궁합 MBTI
          <img src={logoImg} alt="logo" />
        </Link>
      </h1>
      <div className="resultWrapper">
        <h2 style={currentStyle}>{selectMyState}</h2>
        <span>+</span>
        <h2 style={currentYourStyle}>{selectYourState}</h2>
      </div>
      <div className="result__img">
        {getMbtiMatchPercent(selectMyState, selectYourState)[3]}
        <span>Illustrated by 최고심</span>
      </div>
      <div className="result__percent">
        <Number
          num={getRandomPercentByMatch(
            getMbtiMatchPercent(selectMyState, selectYourState)[0]
          )}
        />
        %
      </div>
      <div className="result__title">
        {getMbtiMatchPercent(selectMyState, selectYourState)[1]}
      </div>
      <div className="result__desc">
        {getMbtiMatchPercent(selectMyState, selectYourState)[2]}
      </div>
      <ButtonSmall leftTitle="다시하기"></ButtonSmall>
    </div>
  );
}

export default ResultPage;
